export function checkIfStringEmptyOrUndefined(value: string | undefined) {
  return value === undefined || value === '';
}

export function checkIfStringIsEmptyOrContainsWhiteSpaces(value: string | undefined) {
  return value === undefined || value === '' || /\s/.test(value);
}

export function checkIfStringIsComposedByWhiteSpaceOnly(value: string) {
  return value.trim() === '';
}